// extracted by mini-css-extract-plugin
module.exports = {"ad":"Advert-module--ad--1q3Qv"};